<template>
  <div>
    <b-table :data="emissionsPostes" hoverable>
      <b-table-column
        v-slot="props"
        field="poste"
        width="150"
        :label="$t('compCarbonResultsGHGProtocol.label-1')"
        centered
      >
        <span v-if="props.row.poste !== 'Sous-total'">#</span
        >{{ props.row.poste }}
      </b-table-column>
      <b-table-column
        field="posteDef"
        width="300"
        :label="$t('compCarbonResultsGHGProtocol.label-2')"
        v-slot="props"
      >
        <span v-if="props.row.posteDef.length < 37">
          {{ props.row.posteDef }}
        </span>
        <span v-else>
          <b-tooltip multilined :label="props.row.posteDef" type="is-black">
            {{ props.row.posteDef | truncate(35) }}
          </b-tooltip>
        </span>
      </b-table-column>
      <b-table-column
        field="scope"
        :label="$t('compCarbonResultsGHGProtocol.label-3')"
        centered
      >
        <template v-slot:header="{ column }">
          <b-tooltip
            :label="$t('compCarbonResultsGHGProtocol.gotodoc')"
            type="is-dark"
            append-to-body
            dashed
            multilined
          >
            {{ column.label }}
          </b-tooltip>
        </template>
        <template v-slot="props">
          <span class="tag is-success" v-if="props.row.scope === '1'">
            Scope {{ props.row.scope }}
          </span>
          <span class="tag is-warning" v-if="props.row.scope === '2'">
            Scope {{ props.row.scope }}
          </span>
          <span class="tag is-info" v-if="props.row.scope === '3'">
            Scope {{ props.row.scope }}
          </span>
        </template>
      </b-table-column>
      <b-table-column field="co2" label="CO2" numeric v-slot="props">
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsGHGProtocol.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsGHGProtocol.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.co2) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column field="ch4" label="CH4" numeric v-slot="props">
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsGHGProtocol.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsGHGProtocol.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.ch4) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column field="n2o" label="N2O" v-slot="props" numeric>
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsGHGProtocol.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsGHGProtocol.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.n2o) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column
        field="other"
        v-slot="props"
        :label="$t('compCarbonResultsGHGProtocol.label-4')"
        numeric
      >
        <span v-if="!props.row.computed && isDetailed(props.row)">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsGHGProtocol.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsGHGProtocol.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else-if="isDetailed(props.row)">
          {{ Math.round(props.row.intensity.other) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column
        field="total"
        :label="$t('compCarbonResultsGHGProtocol.label-5')"
        v-slot="props"
        width="150"
        numeric
      >
        <span v-if="!props.row.computed">
          <b-tooltip
            dashed
            :label="$t('compCarbonResultsGHGProtocol.nc')"
            type="is-black"
          >
            {{ $t('compCarbonResultsGHGProtocol.nc.short') }}
          </b-tooltip>
        </span>
        <span v-else>
          {{ Math.round(props.row.intensity.intensity) | splitNumberTons }}
        </span>
      </b-table-column>
      <b-table-column field="poste" label="" centered> </b-table-column>
      <template v-slot:footer>
        <th style="width: 40px">
          <div class="th-wrap is-centered">{{ $t('total') }}</div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap"></div>
        </th>
        <th>
          <div class="th-wrap is-numeric">
            {{ Math.round(intensity.intensity) | splitNumberTons }}
          </div>
        </th>
        <th>
          <div class="th-wrap">
            <b-tooltip :label="$t('display')" type="is-black">
              <b-button
                size="is-small"
                icon-right="bar-chart"
                @click="plotsVisible = true"
              />
            </b-tooltip>
            <b-tooltip :label="$t('download')" type="is-black">
              <b-button
                size="is-small"
                icon-right="download"
                @click="exportTable()"
              />
            </b-tooltip>
          </div>
        </th>
      </template>
    </b-table>
    <b-modal :active.sync="plotsVisible" has-modal-card :width="1100">
      <div class="modal-card" style="width: 1100px">
        <section class="modal-card-body">
          <plots-ghg
            :title="graphicTitle"
            :data0="graphicDataTons0"
            :data1="graphicDataTons1"
            :data2="graphicDataTons2"
            :drill0="drillDataTons0"
            :drill1="drillDataTons1"
            :drill2="drillDataTons2"
          />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  DetailedCarbonIntensity,
  DetailedCarbonIntensities,
  CarbonIntensity,
  CarbonIntensities
} from '@/models/carbon/CarbonIntensity.js'
import '@/plugins/highcharts.js'
import { createExportFile } from '@/utils/files'
import Purchase from '@/models/carbon/Purchase.js'
import Modules from '@/models/Modules.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'GHGProtocol',
  components: {
    'plots-ghg': () => import('@/components/carbon/results/PlotsGHG.vue')
  },
  data () {
    return {
      graphicTitle: '',
      graphicData0: 100.0,
      graphicData1: 100.0,
      graphicData2: 100.0,
      drillData0: [],
      drillData1: [],
      drillData2: [],
      plotsVisible: false
    }
  },
  setup () {
    const ghgiStore = useGHGIStore()
    const coreStore = useCoreStore()
    return { ghgiStore, coreStore }
  },
  computed: {
    ghgi: function () {
      return this.ghgiStore.item
    },
    modules: function () {
      return this.coreStore.activeModules(false)
    },
    graphicDataTons0: function () {
      return this.graphicData0 / 1000
    },
    graphicDataTons1: function () {
      return this.graphicData1 / 1000
    },
    graphicDataTons2: function () {
      return this.graphicData2 / 1000
    },
    drillDataTons0: function () {
      let drillDataTons0 = []
      for (let source of this.drillData0) {
        drillDataTons0.push([source[0], source[1] / 1000])
      }
      return drillDataTons0
    },
    drillDataTons1: function () {
      let drillDataTons1 = []
      for (let source of this.drillData1) {
        drillDataTons1.push([source[0], source[1] / 1000])
      }
      return drillDataTons1
    },
    drillDataTons2: function () {
      let drillDataTons2 = []
      for (let source of this.drillData2) {
        drillDataTons2.push([source[0], source[1] / 1000])
      }
      return drillDataTons2
    },
    intensity: function () {
      let intensity = new CarbonIntensities()
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[5].intensity.intensity,
          this.emissionsPostes[5].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[8].intensity.intensity,
          this.emissionsPostes[8].intensity.uncertainty
        )
      )
      intensity.add(
        new CarbonIntensity(
          this.emissionsPostes[25].intensity.intensity,
          this.emissionsPostes[25].intensity.uncertainty
        )
      )
      return intensity.sum()
    },
    emissionsPostes: function () {
      return [
        {
          poste: '1.1',
          scope: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-1p1'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.2',
          scope: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-1p2'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.3',
          scope: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-1p3'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.4',
          scope: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-1p4'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: '1.5',
          scope: '1',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-1p5'),
          _intensities: new DetailedCarbonIntensities(),
          intensity: new DetailedCarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsGHGProtocol.sub-total'),
          scope: '1',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '2.1',
          scope: '2',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-2p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '2.2',
          scope: '2',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-2p2'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsGHGProtocol.sub-total'),
          scope: '2',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.1',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p1'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.2',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p2'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.3',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p3'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.4',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p4'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.5',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p5'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.6',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p6'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.7',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p7'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.8',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p8'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.9',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p9'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.10',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p10'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.11',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p11'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.12',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p12'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.13',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p13'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.14',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p14'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.15',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p15'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: '3.16',
          scope: '3',
          computed: false,
          posteDef: this.$t('compCarbonResultsGHGProtocol.post-3p16'),
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        },
        {
          poste: this.$t('compCarbonResultsGHGProtocol.sub-total'),
          scope: '3',
          computed: true,
          posteDef: '',
          _intensities: new CarbonIntensities(),
          intensity: new CarbonIntensity()
        }
      ]
    }
  },
  methods: {
    isDetailed (poste) {
      return poste.intensity instanceof DetailedCarbonIntensity
    },
    exportTable () {
      let csvContent = [
        Object.keys(this.emissionsPostes[0])
          .filter((column) => !column.startsWith('_'))
          .join('\t'),
        ...this.emissionsPostes.map(function (item) {
          let toReturn = ''
          for (let colName of Object.keys(item).filter(
            (column) => !column.startsWith('_')
          )) {
            if (colName === 'intensity') {
              toReturn += Math.round(item[colName].intensity) + '\t'
              toReturn += Math.round(item[colName].uncertainty)
            } else {
              toReturn += item[colName] + '\t'
            }
          }
          return toReturn
        })
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')
      createExportFile(csvContent, 'regulatory')
    },
    setGraphicData () {
      this.drillData0 = []
      this.drillData1 = []
      this.drillData2 = []
      this.graphicData0 = Math.round(
        this.emissionsPostes[5].intensity.intensity
      )
      this.graphicData1 = Math.round(
        this.emissionsPostes[8].intensity.intensity
      )
      this.graphicData2 = Math.round(
        this.emissionsPostes[25].intensity.intensity
      )
      for (let i of [...Array(5).keys()]) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData0.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
      if (this.emissionsPostes[6].intensity.intensity > 0) {
        this.drillData1.push([
          this.emissionsPostes[6].posteDef,
          Math.round(this.emissionsPostes[6].intensity.intensity)
        ])
      }
      if (this.emissionsPostes[7].intensity.intensity > 0) {
        this.drillData1.push([
          this.emissionsPostes[7].posteDef,
          Math.round(this.emissionsPostes[7].intensity.intensity)
        ])
      }
      let ids = [...Array(16).keys()]
      ids = ids.map((x) => x + 9)
      for (let i of ids) {
        if (this.emissionsPostes[i].intensity.intensity > 0) {
          this.drillData2.push([
            this.emissionsPostes[i].posteDef,
            Math.round(this.emissionsPostes[i].intensity.intensity)
          ])
        }
      }
    },
    processBuildings () {
      let results = this.ghgi.emissions.buildings
      let index1p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '1.1'
      )
      let index1p4 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '1.4'
      )
      let index2p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '2.1'
      )
      let index2p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '2.2'
      )
      let index3p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.1'
      )
      let index3p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.2'
      )
      let index3p3 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.3'
      )

      // heatings intensity
      this.emissionsPostes[index1p1]._intensities.add(
        new DetailedCarbonIntensity(
          results.heatings.controled.co2,
          results.heatings.controled.ch4,
          results.heatings.controled.n2o,
          results.heatings.controled.other,
          results.heatings.controled.combustion.intensity,
          results.heatings.controled.combustion.uncertainty
        )
      )
      this.emissionsPostes[index1p1].computed = true
      this.emissionsPostes[index2p2]._intensities.add(
        new CarbonIntensity(
          results.heatings.uncontroled.combustion.intensity,
          results.heatings.uncontroled.combustion.uncertainty
        )
      )
      this.emissionsPostes[index2p2].computed = true
      this.emissionsPostes[index3p3]._intensities.add(
        new CarbonIntensity(
          results.heatings.controled.upstream.intensity,
          results.heatings.controled.upstream.uncertainty
        )
      )
      this.emissionsPostes[index3p3]._intensities.add(
        new CarbonIntensity(
          results.heatings.uncontroled.upstream.intensity,
          results.heatings.uncontroled.upstream.uncertainty
        )
      )
      // electricity intensity
      this.emissionsPostes[index2p1]._intensities.add(
        new CarbonIntensity(
          results.electricity.intensity.combustion.intensity,
          results.electricity.intensity.combustion.uncertainty
        )
      )
      this.emissionsPostes[index2p1].computed = true
      this.emissionsPostes[index3p3]._intensities.add(
        new CarbonIntensity(
          results.electricity.intensity.upstream.intensity,
          results.electricity.intensity.upstream.uncertainty
        )
      )
      this.emissionsPostes[index3p3].computed = true
      // refrigerants intensity
      this.emissionsPostes[index1p4]._intensities.add(
        new DetailedCarbonIntensity(
          0.0,
          0.0,
          0.0,
          results.refrigerants.intensity.intensity,
          results.refrigerants.intensity.intensity,
          results.refrigerants.intensity.uncertainty
        )
      )
      this.emissionsPostes[index1p4].computed = true
      // water intensity
      this.emissionsPostes[index3p1]._intensities.add(results.water.intensity)
      this.emissionsPostes[index3p1].computed = true
      // construction intensity
      this.emissionsPostes[index3p2]._intensities.add(
        results.construction.intensity
      )
      this.emissionsPostes[index3p2].computed = true
    },
    processVehicles () {
      let results = this.ghgi.emissions.vehicles
      let index1p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '1.2'
      )
      let index3p3 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.3'
      )
      let index3p6 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.6'
      )
      this.emissionsPostes[index1p2]._intensities.add(
        new DetailedCarbonIntensity(
          results.controled.co2,
          results.controled.ch4,
          results.controled.n2o,
          results.controled.other,
          results.controled.combustion.intensity,
          results.controled.combustion.uncertainty
        )
      )
      this.emissionsPostes[index1p2].computed = true
      this.emissionsPostes[index3p3]._intensities.add(
        new CarbonIntensity(
          results.controled.upstream.intensity,
          results.controled.upstream.uncertainty
        )
      )
      this.emissionsPostes[index3p3].computed = true
      this.emissionsPostes[index3p6]._intensities.add(
        new CarbonIntensity(
          results.controled.manufacturing.intensity,
          results.controled.manufacturing.uncertainty
        )
      )
      this.emissionsPostes[index3p6]._intensities.add(
        new CarbonIntensity(
          results.uncontroled.intensity,
          results.uncontroled.uncertainty
        )
      )
      this.emissionsPostes[index3p6].computed = true
    },
    processCommutes () {
      let results = this.ghgi.emissions.commutes
      // add the value to the right post
      let index3p7 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.7'
      )
      this.emissionsPostes[index3p7]._intensities.add(results.intensity)
      this.emissionsPostes[index3p7].computed = true
    },
    processFoods () {
      let results = this.ghgi.emissions.foods
      // add the value to the right post
      let index3p1 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.1'
      )
      this.emissionsPostes[index3p1]._intensities.add(results.intensity)
      this.emissionsPostes[index3p1].computed = true
    },
    processTravels () {
      let results = this.ghgi.emissions.travels
      // add the value to the right post
      let index3p6 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.6'
      )
      this.emissionsPostes[index3p6]._intensities.add(results.intensity)
      this.emissionsPostes[index3p6].computed = true
    },
    processDevices () {
      let results = this.ghgi.emissions.devices
      // add the value to the right post
      let index3p2 = this.emissionsPostes.findIndex(
        (obj) => obj.poste === '3.2'
      )
      this.emissionsPostes[index3p2]._intensities.add(results.intensity)
      this.emissionsPostes[index3p2].computed = true
    },
    processPurchases () {
      let results = this.ghgi.emissions.purchases
      // add the value to the right post
      for (let scat of Object.keys(results.catGHGP)) {
        let cindex = this.emissionsPostes.findIndex((obj) => obj.poste === scat)
        if (cindex !== -1) {
          this.emissionsPostes[cindex]._intensities.add(results.catGHGP[scat])
        }
      }
      // set as computed all purchases scopes
      for (let catGHGP of Purchase.getCatGHGP()) {
        let cindex = this.emissionsPostes.findIndex(
          (obj) => obj.poste === catGHGP.toString()
        )
        if (cindex !== -1) {
          this.emissionsPostes[cindex].computed = true
        }
      }
    },
    processRActivities () {
      let results = this.ghgi.emissions.ractivities
      // add the value to the right post
      for (let key of Object.keys(results.intensitiesGHGP)) {
        let index = this.emissionsPostes.findIndex((obj) => obj.poste === key)
        if (key.startsWith('1.')) {
          this.emissionsPostes[index]._intensities.add(
            new DetailedCarbonIntensity(
              results.intensitiesGHGP[key].co2,
              results.intensitiesGHGP[key].ch4,
              results.intensitiesGHGP[key].n2o,
              results.intensitiesGHGP[key].other,
              results.intensitiesGHGP[key].intensity,
              results.intensitiesGHGP[key].uncertainty
            )
          )
        } else {
          this.emissionsPostes[index]._intensities.add(
            results.intensitiesGHGP[key]
          )
        }
        this.emissionsPostes[index].computed = true
      }
    },
    updateValues () {
      this.emissionsPostes[5]._intensities = new CarbonIntensities()
      for (let i of [...Array(5).keys()]) {
        this.emissionsPostes[5]._intensities.add(
          this.emissionsPostes[i]._intensities
        )
      }
      this.emissionsPostes[8]._intensities = new CarbonIntensities()
      this.emissionsPostes[8]._intensities.add(
        this.emissionsPostes[6]._intensities
      )
      this.emissionsPostes[8]._intensities.add(
        this.emissionsPostes[7]._intensities
      )
      this.emissionsPostes[25]._intensities = new CarbonIntensities()
      let ids = [...Array(16).keys()]
      ids = ids.map((x) => x + 9)
      for (let i of ids) {
        this.emissionsPostes[25]._intensities.add(
          this.emissionsPostes[i]._intensities
        )
      }
      for (let emission of this.emissionsPostes) {
        emission.intensity = emission._intensities.sum()
      }
    },
    process () {
      // First reset values
      for (let emission of this.emissionsPostes) {
        if (parseFloat(emission.poste) <= 1.5) {
          emission._intensities = new DetailedCarbonIntensities()
        } else {
          emission._intensities = new CarbonIntensities()
        }
      }
      this.ghgiStore.compute()
      if (this.modules.includes(Modules.BUILDINGS)) {
        this.processBuildings()
      }
      if (this.modules.includes(Modules.VEHICLES)) {
        this.processVehicles()
      }
      if (this.modules.includes(Modules.COMMUTES)) {
        this.processCommutes()
      }
      if (this.modules.includes(Modules.TRAVELS)) {
        this.processTravels()
      }
      if (this.modules.includes(Modules.DEVICES)) {
        this.processDevices()
      }
      if (this.modules.includes(Modules.PURCHASES)) {
        this.processPurchases()
      }
      if (this.modules.includes(Modules.FOODS)) {
        this.processFoods()
      }
      if (this.modules.includes(Modules.RACTIVITIES)) {
        this.processRActivities()
      }
      // update final values
      this.updateValues()
      // affichage des graphs
      this.setGraphicData()
    }
  },
  mounted () {
    this.process()
  }
}
</script>
